<script lang="ts" setup>
import AuthAPI from '~/api/auth';
import { PhoneMask } from '~/utils/phoneFormatter';

const props = defineProps<{
  phone: string;
  withTitle?: boolean;
}>();
const emit = defineEmits<{
  (event: 'change-phone'): void;
  (event: 'to-email'): void;
  (event: 'completed'): void;
}>();
const authorizationTheme = inject(
  INJECTION_KEYS.AuthorizationTheme,
  ThemeEnum.dark,
);

const { t } = useI18n();
const tokenStore = useTokenStore();

const isError = ref(false);
const isLoading = ref(false);

const onSubmit = (code: string) => {
  isError.value = false;

  if (!isLoading.value) {
    isLoading.value = true;
    AuthAPI.checkPhoneCode({
      body: { code, phone: formatPhone(props.phone, PhoneMask.simple) },
    })
      ?.then((data) => {
        tokenStore.value = data.token;
        emit('completed');
      })
      .catch(() => {
        isError.value = true;
      })
      .finally(() => {
        isLoading.value = false;
      });
  }
};
</script>

<template>
  <div class="authPhoneCodeForm">
    <h2 v-if="withTitle" class="authorizationComponent__title">
      {{ t('title') }}
    </h2>

    <ProfilePhoneCodeForm
      @complete="onSubmit"
      @input="isError = false"
      @change-phone="emit('change-phone')"
      :repeat-code="
        (flash) =>
          AuthAPI.phoneAuth({
            body: { phone: formatPhone(phone, PhoneMask.simple), flash },
          })
      "
      :call-attempts="1"
      :phone="phone"
      :failed="isError"
      :dark="authorizationTheme === ThemeEnum.dark"
      :readonly="isLoading"
      data-test-id="auth-phone-code-input"
    />

    <div class="authPhoneCodeForm__links">
      <button
        @click="emit('to-email')"
        class="authorizationComponent__link"
        type="button"
      >
        {{ t('to_email') }}
      </button>
      <!-- TODO: Нет никакого дейтсвия-->
      <button class="authorizationComponent__link" type="button">
        {{ t('problem') }}
      </button>
    </div>
  </div>
</template>

<i18n>
ru:
  title: Введите код
  to_email: Войти по почте
  problem: Не приходит СМС

en:
  title: Enter the code
  to_email: Log in via email
  problem: No SMS
</i18n>

<style lang="scss">
.authPhoneCodeForm {
  display: flex;
  flex-direction: column;
  align-items: center;

  &__links {
    display: flex;
    gap: 42px;
    margin-top: 29px;
  }
}
</style>
